import { render, staticRenderFns } from "./AscPlotHeaderWrapper.vue?vue&type=template&id=5be442cb&"
import script from "./AscPlotHeaderWrapper.vue?vue&type=script&lang=js&"
export * from "./AscPlotHeaderWrapper.vue?vue&type=script&lang=js&"
import style0 from "./AscPlotHeaderWrapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports